import { MDBDataTable } from "mdbreact";
import { Navbar } from "../Navbar/NavBar";
import VisitorLeadsFilters from "./VisitorLeadsFilters";
import { useState } from "react";
import "./LodhaForm.css"
import { DownloadLeadsCSV } from "./DownloadLeadsCSV";
import { DownloadLeadsXlsx } from "./DownloadLeadsXlsx";

export const LeadsTable = ({
	data,
	type,
	sortVisitorList,
	filtersList,
	GetUpdatedVisitorLeads,
	setIsModalOpen,
	allLeadsList = [],
	selectedFilter, setSelectedFilter,
	selectedFilterValue,
	setSelectedFilterValue
	// currentPage,
	// pageSize,
	// onPageChange,
	// onPageSizeChange,
	// disableNext
}) => {
	// const [selectedFilter, setSelectedFilter] = useState([]);
	return (
		<>
			<div className="main-dashboard">
				<Navbar />
				<div className="margin-left px-md-3">
					<div className="container-fluid pt-5">
						<div className="row pt-4 mt-4 mb-4 px-0">
							<div className="col-12 px-0">
								<div className="default-card" style={{
									minHeight: "calc(100vh - 120px)"
								}}>
									<div className="d-flex flex-column flex-lg-row align-items-start align-items-lg-center justify-content-between">
										<div className="card-heading" style={{
											flex: 1
										}}>
											<h4 className="text-nowrap">{type}</h4>
										</div>
										<div className="fiter-website-name w-100 text-start">
											<div className="d-flex d-lg-none gap-2">
												<DownloadLeadsCSV list={allLeadsList} />
												<DownloadLeadsXlsx list={allLeadsList} />
											</div>
											<div className="mt-1 mb-0 mb-sm-1 pb-3 pb-sm-2 add-visitor-btn d-flex justify-content-end gap-2">
												<div className="d-none d-lg-flex gap-2">
													<DownloadLeadsCSV list={allLeadsList} />
													<DownloadLeadsXlsx list={allLeadsList} />
												</div>
												<button
													type="button"
													className="visitor-btn"
													onClick={() => setIsModalOpen(true)}
												>
													Add Visitor Details
												</button>
											</div>
										</div>
									</div>

									<VisitorLeadsFilters
										sortVisitorList={sortVisitorList}
										filtersList={filtersList}
										GetUpdatedVisitorLeads={GetUpdatedVisitorLeads}
										selectedFilter={selectedFilter} setSelectedFilter={setSelectedFilter}
										selectedFilterValue={selectedFilterValue} setSelectedFilterValue={setSelectedFilterValue}
									/>



									<MDBDataTable
										noBottomColumns
										hover
										// searching={false}
										data={data}
										// paging={false} // disable built-in pagination
										className="latest-ouotes-table"
									/>

									{/* Custom Pagination */}
									{/* <div className="d-flex justify-content-between align-items-center mt-3">

										<select
											value={pageSize}
											disabled={disableNext}
											onChange={(e) => {
												const filteredUndefined = selectedFilter?.filter(det => det);
												const value = filteredUndefined?.length ? filteredUndefined?.join(' and ') : '';
												onPageSizeChange(Number(e.target.value, value))
											}}
										>
											<option value={5}>5</option>
											<option value={10}>10</option>
											<option value={15}>15</option>
											<option value={30}>30</option>
										</select>

										<div className="next-prev">
											<button
												disabled={currentPage === 1}
												onClick={() => {
													const filteredUndefined = selectedFilter?.filter(det => det);
													const value = filteredUndefined?.length ? filteredUndefined?.join(' and ') : '';
													onPageChange(currentPage - 1, value)
												}}
											>
												Prev
											</button>

											<span className="mx-2">
												Page {currentPage}
											</span>

											<button
												disabled={disableNext}
												onClick={() => {

													const filteredUndefined = selectedFilter?.filter(det => det);
													const value = filteredUndefined?.length ? filteredUndefined?.join(' and ') : '';
													onPageChange(currentPage + 1, value)
												}}
											>
												Next
											</button>
										</div>

									</div> */}

								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};